import Image from "next/image";
import { useRouter } from "next/router";

import { useMemo } from "react";

import { Entity } from "models/entity";
import { twMerge } from "tailwind-merge";

import EntityCard from "components/EntityCard";
import EntitySmartScore from "components/EntitySmartScore";
import useAuthentication from "hooks/useAuthentication";

import EntityPageTabs from "../EntityPageTabs";

interface Props {
  children: any;
  entity: Entity;
  slug: string;
  hideSmartScore: boolean;
  toggle: any;
  setSmartScoreEmpty: (any?: any) => void;
  showPriceChart: boolean;
  snapshotWidget: any;
}

export default function EntityPageLayoutMobile({
  children,
  entity,
  slug,
  hideSmartScore,
  setSmartScoreEmpty,
  toggle,
  showPriceChart,
  snapshotWidget,
}: Props) {
  const router = useRouter();

  const { account: loggedInAccount } = useAuthentication();

  const isPage = useMemo(() => {
    return (
      router.route.endsWith("/analytics") || router.route.endsWith("/more")
    );
  }, [router.route]);

  return (
    <div className={twMerge("mt-[54px]", isPage && "pt-[15px]")}>
      {!isPage && (
        <>
          <div>{entity && <EntityCard {...{ entity }} />}</div>
          {showPriceChart && (
            <>
              <div className={twMerge("p-[15px]", hideSmartScore && "hidden")}>
                {toggle}
                {entity && !loggedInAccount?.isCorporateOfficer && (
                  <EntitySmartScore
                    entity={entity}
                    onDataLoaded={(isEmpty) => setSmartScoreEmpty(isEmpty)}
                  />
                )}
              </div>
              {!router.route.endsWith("/analytics") && snapshotWidget}
            </>
          )}
          <div className="border-t border-x-0 border-b-0 border-[#cccccc88] mt-[12px] border-solid">
            <EntityPageTabs slug={slug} entity={entity} />
          </div>
        </>
      )}
      {children}
      {showPriceChart && !isPage && (
        <button
          className="fixed bottom-[45px] right-[15px] flex items-center justify-center w-[50px] h-[50px] bg-smart-teal rounded-full border-0"
          onClick={() => {
            router.push(`/entities/${slug}/analytics`);
          }}
        >
          <Image
            src={require("./assets/chart-bar.svg")}
            alt="chart-bar"
            width={18}
            height={18}
          />
        </button>
      )}
    </div>
  );
}
